/**
 * Enum representing the steps in the flowsheet configuration
 */
enum ConfigureFlowsheetModalStepEnum {
    Configuration = "Configuration",
    TemplateType = "TemplateType"
}

export { ConfigureFlowsheetModalStepEnum };
